<script setup lang="ts">
import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';
import Banner from '@/components/banner.vue';
import { Head } from '@inertiajs/vue3';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
    <VApp>
        <Head :title="t('flight_status.project_title')" />
        <AppHeader />
        <Banner :title="t('banner.title')" :subtitle="t('banner.subtitle')" />
        <VMain>
            <slot />
        </VMain>
        <AppFooter />
    </VApp>
</template>
